var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select } from 'ui/styled';
import { dataLoader } from 'utils/helpers';
import useOrganizationSelect from './useOrganizationSelect';
var OrganizationSelect = function (_a) {
    var disabled = _a.disabled, onChange = _a.onChange, _b = _a.placeholder, placeholder = _b === void 0 ? "Organization" : _b, showAnyOption = _a.showAnyOption, size = _a.size, organizationId = _a.value, mode = _a.mode, maxTagCount = _a.maxTagCount, maxTagPlaceholder = _a.maxTagPlaceholder, loading = _a.loading, restProps = __rest(_a, ["disabled", "onChange", "placeholder", "showAnyOption", "size", "value", "mode", "maxTagCount", "maxTagPlaceholder", "loading"]);
    var _c = useOrganizationSelect({
        organizationId: organizationId,
        showAnyOption: showAnyOption,
        mode: mode
    }), functions = _c.functions, data = _c.data;
    var dataLoading = data.loading, organizationOptions = data.organizationOptions;
    var debouncedSearch = functions.debouncedSearch, onPopupScroll = functions.onPopupScroll;
    return (_jsx(Select, __assign({ disabled: disabled, onChange: onChange, value: organizationId, size: size, placeholder: placeholder, mode: mode, maxTagCount: maxTagCount, allowClear: true, showSearch: { filterOption: false, onSearch: debouncedSearch }, notFoundContent: dataLoader(loading), onPopupScroll: onPopupScroll, "data-test": "organizationFilter", options: organizationOptions, maxTagPlaceholder: maxTagPlaceholder, popupMatchSelectWidth: false, loading: loading || dataLoading }, restProps)));
};
export default OrganizationSelect;
